import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "searchSlotsContainer" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "flex w-full flex-col gap-4" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = {
  key: 0,
  class: "therapiesSection mt-6 mb-4"
}
const _hoisted_7 = { class: "dateTimeSection" }
const _hoisted_8 = { class: "flex justify-between" }
const _hoisted_9 = { class: "w-1/2 pr-4" }
const _hoisted_10 = { class: "inputGroup mb-3" }
const _hoisted_11 = { class: "inputWrapper" }
const _hoisted_12 = { class: "inputGroup mb-3" }
const _hoisted_13 = { class: "inputWrapper" }
const _hoisted_14 = { class: "w-1/2 pl-4" }
const _hoisted_15 = { class: "inputGroup mb-3" }
const _hoisted_16 = { class: "inputWrapper" }
const _hoisted_17 = { class: "inputGroup mb-3" }
const _hoisted_18 = { class: "inputWrapper" }
const _hoisted_19 = { class: "daysSection my-4" }
const _hoisted_20 = { class: "daysWrapper" }
const _hoisted_21 = { class: "actionsSection mt-5 flex gap-4 justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_TherapyCard = _resolveComponent("TherapyCard")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[15] || (_cache[15] = _createElementVNode("h2", { class: "sectionTitle my-2" }, "Appointment Search", -1)),
    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "sectionSubtitle mb-3" }, "Configure your search parameters to find available appointment slots", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_select, {
            modelValue: _ctx.location,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.location) = $event)),
            items: _ctx.userLocations,
            "item-title": "name",
            "item-value": "uuid",
            density: "comfortable",
            label: "Location",
            variant: "solo",
            class: "timeSelectClass",
            disabled: !_ctx.userLocations
          }, null, 8, ["modelValue", "items", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_v_select, {
            modelValue: _ctx.template,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.template) = $event)),
            items: _ctx.templates,
            "item-title": "name",
            "item-value": "id",
            density: "comfortable",
            label: "Template",
            variant: "solo",
            disabled: !_ctx.templates,
            class: "timeSelectClass",
            "menu-props": { contentClass: 'showScroller'}
          }, null, 8, ["modelValue", "items", "disabled"])
        ])
      ])
    ]),
    (_ctx.therapies.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.therapies, (therapy) => {
            return (_openBlock(), _createElementBlock("span", {
              key: therapy.therapyUUID
            }, [
              _createVNode(_component_TherapyCard, {
                therapy: therapy,
                onUpdateDoctorsList: _ctx.updateDoctorsList
              }, null, 8, ["therapy", "onUpdateDoctorsList"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "subsectionTitle mt-6 mb-3" }, "Date and Time", -1)),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[8] || (_cache[8] = _createElementVNode("label", { class: "inputLabel" }, "Start Date:", -1)),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.startDate)
                ? (_openBlock(), _createBlock(_component_DatePicker, {
                    key: 0,
                    "selected-date": _ctx.startDate,
                    onUpdateDate: _cache[2] || (_cache[2] = (date) => this.startDate = date),
                    format: "MM/DD/YYYY"
                  }, null, 8, ["selected-date"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _cache[9] || (_cache[9] = _createElementVNode("label", { class: "inputLabel" }, "End Date:", -1)),
            _createElementVNode("div", _hoisted_13, [
              (_ctx.endDate)
                ? (_openBlock(), _createBlock(_component_DatePicker, {
                    key: 0,
                    "selected-date": _ctx.endDate,
                    onUpdateDate: _cache[3] || (_cache[3] = (date) => this.endDate = date),
                    format: "MM/DD/YYYY"
                  }, null, 8, ["selected-date"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "inputLabel" }, "Start Time:", -1)),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedStartTime,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedStartTime) = $event)),
                items: _ctx.times,
                "item-title": "label",
                "item-value": "value",
                "hide-details": "",
                variant: "solo",
                density: "compact",
                "menu-props": { contentClass: 'showScroller'},
                class: "timeSelectClass"
              }, null, 8, ["modelValue", "items"])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[11] || (_cache[11] = _createElementVNode("label", { class: "inputLabel" }, "End Time:", -1)),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_v_select, {
                modelValue: _ctx.selectedEndTime,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedEndTime) = $event)),
                items: _ctx.times,
                "item-title": "label",
                "item-value": "value",
                "hide-details": "",
                variant: "solo",
                density: "compact",
                "menu-props": { contentClass: 'showScroller'},
                class: "timeSelectClass"
              }, null, 8, ["modelValue", "items"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "inputLabel mb-2" }, "Days:", -1)),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_v_checkbox, {
          modelValue: _ctx.daysSelectedAll,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.daysSelectedAll) = $event)),
          label: "All",
          value: true,
          "hide-details": "",
          density: "compact",
          class: "dayCheckbox"
        }, null, 8, ["modelValue"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weekDays, (day) => {
          return (_openBlock(), _createBlock(_component_v_checkbox, {
            key: day,
            modelValue: _ctx.days,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.days) = $event)),
            label: day,
            value: day,
            "hide-details": "",
            density: "compact",
            class: "dayCheckbox"
          }, null, 8, ["modelValue", "label", "value"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_v_btn, {
        class: "searchButton text-white",
        color: "primary",
        elevation: "2",
        size: "large",
        variant: "flat",
        onClick: _ctx.sendSearchQuery
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { class: "mr-1" }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("mdi-magnify", -1)
            ]))]),
            _: 1
          }),
          _cache[14] || (_cache[14] = _createTextVNode(" SEARCH SLOTS ", -1))
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_v_checkbox, {
        label: "Auto-update",
        value: true,
        "hide-details": "",
        disabled: "",
        density: "compact",
        class: "autoUpdateCheckbox ml-4"
      })
    ])
  ]))
}